export const buttonTheme = {
    confirm: {
        color: 'white',
        background: '#FF8200',
    },
    remove: {
        background: '#CF1322',
        color: 'white',
    },
    cancel: {
        color: '#142246',
        background: '#F2F2F2'
    },
    cancelEmpty: {
        background: '#FFFFFF',
        color: '#F5222D'
    }
}
